import { render } from "./FormTop.vue?vue&type=template&id=cd59615a"
import script from "./FormTop.vue?vue&type=script&lang=js"
export * from "./FormTop.vue?vue&type=script&lang=js"

import "./FormTop.vue?vue&type=style&index=0&id=cd59615a&lan=scss&lang=css"

import exportComponent from "/builds/cu2207/business/produkter.dk/pfp-public-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__